import { IRecommendationRepository } from '../interfaces';
import LogUtil from '../../../core/utils/LogUtil';
import { API_BASE_URL } from '../../../core/config/api';

export class RecommendationRepositoryImpl extends IRecommendationRepository {
  constructor(apiClient) {
    super();
    this.apiClient = apiClient;
  }

  /**
   * 팜인사이트 안내 — GET /pharminsight/guide?edi=&brn= (인증 불필요)
   * 응답 data: { situation_text, cautions[], checks:{monitor[],counsel[]}, supplements[], purchase_checks[] }
   */
  async getPharmInsightGuide(ediCodes, brn) {
    try {
      return await this.apiClient.get(`${API_BASE_URL}/pharminsight/guide`, {
        params: { edi: ediCodes.join(','), brn },
      });
    } catch (error) {
      LogUtil.error('[RecommendationRepository] 팜인사이트 안내 조회 실패:', error);
      throw error;
    }
  }
}
